import moment from 'moment';

import { IsoWeek, IsoMonth, IsoWeekOrMonth, ISO_TYPE_WEEK, ISO_TYPE_MONTH } from './month-week-value';

export function isoWeekToMoment(isoWeek: IsoWeek) {
	return moment().year(isoWeek.year).isoWeek(isoWeek.value);
}

export function isoMonthToMoment(isoMonth: IsoMonth) {
	return moment().year(isoMonth.year).month(isoMonth.value - 1).startOf('month');
}

export function isoMonthToDate(isoMonth: IsoMonth) {
	return isoMonthToMoment(isoMonth).toDate();
}

export function isoWeekOrMonthToMoment(isoWeekOrMonth: IsoWeekOrMonth) {
	return isoWeekOrMonth.type === ISO_TYPE_WEEK
		? isoWeekToMoment(isoWeekOrMonth)
		: isoMonthToMoment(isoWeekOrMonth);
}

export function parseIsoWeekOrMonth(monthWeekValue: string) {
	if (monthWeekValue.length !== 8) {
		throw new Error(`expected 8 characters for month-week value, but found ${
			monthWeekValue.length } characters in ${ monthWeekValue }`);
	}
	const yearText = monthWeekValue.slice(0, 4);
	// char 5: '-'
	const monthOrWeekText = monthWeekValue.slice(5, 6);
	const valueText = monthWeekValue.slice(6);

	const year = Number(yearText);
	const month = monthOrWeekText === 'M';
	const value = Number(valueText);
	return month ? new IsoMonth(value, year) : new IsoWeek(value, year);
}

export function isoMonthParse(isoMonthAsString: string) {
	const isoWeekOrMonth = parseIsoWeekOrMonth(isoMonthAsString);
	if (isoWeekOrMonth.type !== ISO_TYPE_MONTH) {
		throw new Error(`expected ISO Month, but found '${ isoMonthAsString }'`);
	}
	return isoWeekOrMonth;
}
